import React, {Component} from "react";
import {connect} from "react-redux";

import * as serverActions from "../../../actions/serverActions";

import UpdateDatabasesPanelComponent from "../../../components/scenes/incompatible/UpdateDatabasesPanel";

class UpdateDatabasesPanel extends Component {
    render() {
        return (
            <UpdateDatabasesPanelComponent
                setupSoftware={this.props.setupSoftware}
                numberOfUpdates={this.props.numberOfUpdates}
                databaseList={this.props.databaseList}
                updateDatabaseList={this.props.updateDatabaseList}
                invalidDatabaseList={this.props.invalidDatabaseList}
                loading={this.props.loading}
                updateDatabases={this.props.dispatchUpdateDatabasesAction}
                getAllDatabaseListAndSkipUpdate={this.props.dispatchGetAllDatabaseListAndSkipUpdateAction}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        setupSoftware: store.module.setupSoftware,
        numberOfUpdates: store.server.numberOfUpdates,
        databaseList: store.server.databaseList,
        updateDatabaseList: store.server.updateDatabaseList,
        invalidDatabaseList: store.server.invalidDatabaseList,
        loading: store.server.updatingDatabase
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchUpdateDatabasesAction: () => {
            dispatch(serverActions.updateDatabases());
        },
        dispatchGetAllDatabaseListAndSkipUpdateAction: () => {
            dispatch(serverActions.getAllDatabaseListAndSkipUpdate());
        }
    };
};

export default UpdateDatabasesPanel = connect(mapStoreToProps, mapDispatchToProps)(UpdateDatabasesPanel);
